import styled from 'styled-components';
import { font, query, space, color } from '@design/templateFns';

export const DevelopmentCardInner = styled.div`
  background-color: ${color('gray2')};
  a {
    cursor: pointer;
  }

  @media screen and (${query.atLeast('desktop')}) {
    a:hover {
      span {
        margin-right: 0;
      }
      svg {
        opacity: 1;
      }
    }

    span {
      margin-right: -41px; //33px of arrow + 8px of arrow margin
      transition: margin-right 0.2s ease-in-out;
    }

    svg {
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }
  }
`;

export const ImageGradient = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(337deg, rgba(0, 0, 0, 0.4) 4%, rgba(0, 0, 0, 0) 25%);
`;

export const Title = styled.div`
  position: absolute;
  bottom: ${space('lg')};
  right: ${space('xl')};
  text-transform: uppercase;
  ${font('eyebrow-sm')};
  color: #fff;
  padding: 0;
  padding-left: 8px;
  text-align: right;
  text-shadow: 2px 4px 15px rgba(0, 0, 0, 0.1);
  line-height: 1;
  display: flex;
  align-items: center;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('eyebrow-md')};
  }

  svg {
    margin-left: ${space('sm')};
  }
  @media screen and (${query.below('tablet')}) {
    svg {
      display: none;
    }
  }
`;

// For use in Story
export const StoryWrapper = styled.div`
  display: flex;
`;
